"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationEntityType = void 0;
var ConfigurationEntityType;
(function (ConfigurationEntityType) {
    ConfigurationEntityType["CustomerDefault"] = "CUSTOMER_DEFAULT";
    ConfigurationEntityType["Integration"] = "INTEGRATION";
    ConfigurationEntityType["JiraProject"] = "JIRA_PROJECT";
    ConfigurationEntityType["DataContributor"] = "DATA_CONTRIBUTOR";
    ConfigurationEntityType["GitRepository"] = "GIT_REPOSITORY";
    ConfigurationEntityType["InsightRule"] = "INSIGHT_RULE";
    ConfigurationEntityType["Team"] = "TEAM";
})(ConfigurationEntityType = exports.ConfigurationEntityType || (exports.ConfigurationEntityType = {}));
//# sourceMappingURL=index.js.map